import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "../../../components/Badge";
import { formatPriceWithLocale } from "../../../utils/numbers";
import { BedsIncludedIcon } from "./BedsIncludedIcon";

/** A pill over a card's photo, bottom-right, saying the stay comes with extra beds. */
export const ExtraBedsBadge: React.FC<{
  count: number;
  pricePerNight?: number | null;
}> = ({ count, pricePerNight }) => {
  const { t } = useTranslation();
  if (count <= 0) return null;
  const variant = count === 1 ? "single" : "multiple";

  return (
    <Badge
      variant="default"
      data-testid="extra-beds-badge"
      icon={<BedsIncludedIcon className="h-3.5 w-3.5" />}
      className="pointer-events-none absolute bottom-2 right-2 z-10 shadow-sm"
      text={
        pricePerNight
          ? t(`ad_beds.badge_${variant}_priced`, {
              n: count,
              price: formatPriceWithLocale(pricePerNight),
              currency: t("booking.currency"),
            })
          : t(`ad_beds.badge_${variant}`, { n: count })
      }
    />
  );
};
